import React, { useEffect, useState } from 'react';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { DatabrainBubbleContent } from '@/pages/home/pages/home/components/DataSource';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import DataBrainIcon from '@/pages/intelligence/assets/svg/dataSource/databarin-bg.svg';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import { Bubble } from 'tea-component';
import { useIntl, useSelector, getLocale } from 'umi';
import { valueFormat, growthFormat } from '@/pages/intelligence/utils/commonUtils';
import { FILTER_NAMESPACE } from '@/pages/intelligence/models/filter';
import {
  DataSourceBubbleInfo,
  DATASOURCE_NAME,
} from '@/pages/intelligence/components/DataSourceComponents';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import useCountriesNames from '@intelligence/hooks/useCountriesNames';
import { buildMetricCompareData } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/metricCompare';

interface PHeatColumnType {
  key: string;
  title: string;
  dataSource: string;
  currentSortKey: string;
  currentSortValue: '' | 'desc' | 'asc';
  onSortChage: (e: SortByItemType) => void;
  sortMetric: string;
  textContent: string;
  width: number;
  width_cn?: number | 'auto';
}

export const PHeatColumn = (params: PHeatColumnType) => {
  const { currentSortKey, currentSortValue, onSortChage, width = 150, width_cn } = params;

  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const localeWidth = locale === LANGUAGE_CN ? width_cn || width : width;

  return {
    key: 'popularity',
    width: localeWidth,
    align: 'center',
    header: () => {
      /** 当不是环比排序时，表格标题文本有提示文本 */
      return (
        <CloumsCenter width={localeWidth} align={'right'}>
          <SortBy
            title={formatMessage({ id: `dbi_top_pheat` })}
            defaultKey={currentSortKey}
            defaultValue={currentSortValue}
            svgIcon={DataBrainIcon}
            list={[
              {
                key: 'popularity_0',
                sortMetric: 'popularity',
                text: formatMessage({ id: `dbi_top_pheat` }),
                title: formatMessage({ id: `dbi_top_pheat` }),
              },
            ]}
            onChange={onSortChage}
            svgTip={<DatabrainBubbleContent sourceNameLocalId={'P.Heat'} metric={'databarin'} />}
            content={
              <>
                <p>{formatMessage({ id: `dbi_info_pheat` })}</p>
                <span>
                  {formatMessage({ id: `dbi_info_pheat_items_are_listed` })}
                  <span style={{ display: 'inline-block', width: '5px' }}></span>
                  {formatMessage({
                    id: `dbi_info_pheat_the_predicted_value`,
                  })}
                  <br />
                  <span>
                    {formatMessage({
                      id: `dbi_info_pheat_the_parameter_factors`,
                    })}
                  </span>
                  <span style={{ color: '#326FF0', paddingLeft: 6 }}>
                    {formatMessage({
                      id: `dbi_learnmore`,
                    })}
                  </span>
                </span>
              </>
            }
          />
        </CloumsCenter>
      );
    },
    render: (cvm: any) => {
      return (
        <CloumsCenter width={localeWidth} align={'right'}>
          {cvm.popularity}
        </CloumsCenter>
      );
    },
  };
};

export const CountryColumn = (params = {}) => {
  const { width = 240 } = params;
  const { findCountryLocalName } = useCountriesNames();
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const getUppertoName = (upperval, countryOptions) => {
    const arrtemp = upperval?.toLowerCase()?.split(',') || [];
    const nametemp = [];

    countryOptions.forEach((item) => {
      item?.country_set?.forEach((t) => {
        if (arrtemp.includes(t?.country_code)) {
          nametemp.push(t);
        }
      });
    });

    return nametemp.length > 0
      ? nametemp
          .map((item) =>
            locale === LANGUAGE_CN
              ? item?.country_name_ch || item?.country_name_en
              : item?.country_name_en,
          )
          .join('; ')
      : '';
  };

  const getRegionCountries = (arr) => {
    return arr
      .map((item, idx, srcArr) => {
        const regionNameLocal = findCountryLocalName(item?.region_full_name);
        const markets = item?.market_full_names
          ?.split(';')
          .filter((item: string) => item?.trim() !== '');

        const marketsFullName =
          locale === LANGUAGE_CN
            ? markets
                .map((market: string) => {
                  const marketNameItem = findCountryLocalName(market?.trim());
                  return marketNameItem;
                })
                .join('; ')
            : item?.market_full_names;

        return `<p style="font-weight:bold">${regionNameLocal} ${item?.market_count}</p>
           <p>${marketsFullName}</p>${idx + 1 >= srcArr.length ? '' : '<br>'}`;
      })
      .join('');
  };

  const { mobilePheatMarketFilter } = useSelector((state) => {
    // @ts-ignore
    const { mobilePheatMarketFilter } = state[FILTER_NAMESPACE];
    return {
      mobilePheatMarketFilter,
    };
  });

  return {
    key: 'country',
    width,
    align: 'left',
    header: (
      <CloumsCenter width={width} align="left">
        <div className="header-other">{formatMessage({ id: 'dbi_top_country' })}</div>
      </CloumsCenter>
    ),
    render: (cvm) => {
      if (!cvm?.markets?.length) {
        return (
          <CloumsCenter width={width} align={'left'}>
            -
          </CloumsCenter>
        );
      }
      return (
        <>
          <Bubble
            style={{ maxWidth: '480px' }}
            content={
              cvm?.markets ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: getRegionCountries(cvm?.region_market_info || []),
                  }}
                ></span>
              ) : null
            }
            dark
          >
            <div className="dbi-table-column">
              {getUppertoName(
                cvm?.markets || '',
                mobilePheatMarketFilter.data !== null ? mobilePheatMarketFilter.data : [],
              ) || '-'}
            </div>
          </Bubble>
        </>
      );
    },
  };
};

interface MetricColumnType {
  key: string;
  title: string;
  dataSource: string;
  currentSortKey: string;
  currentSortValue: '' | 'desc' | 'asc';
  onSortChage: (e: SortByItemType) => void;
  sortMetric: string;
  textContent: string;
  svgIcon: string;
  isNoDropdown: boolean;
  width?: number | 'auto';
  width_cn?: number | 'auto';
  entityType?: string;
  showCompareBubble?: boolean;
}
export const CommonMetricColumn = (params: MetricColumnType) => {
  const {
    key,
    title,
    sortMetric,
    dataSource,
    currentSortKey,
    currentSortValue,
    textContent,
    svgIcon,
    isNoDropdown,
    width = 220,
    width_cn,
    onSortChage,
    entityType = '',
    showCompareBubble = false,
  } = params;

  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const localeWidth = locale === LANGUAGE_CN ? width_cn || width : width;
  const valueFormatter = (rawValue?: number | string) => {
    return String(valueFormat(rawValue));
  };

  const getDataCompareData = (cvm: any, metric: any) => {
    if (!showCompareBubble) {
      return undefined;
    }

    return buildMetricCompareData({
      metric,
      granularity: 'daily',
      startDate: metric?.start_date,
      endDate: metric?.end_date,
      entityType,
      title: cvm?.name,
      icon: cvm?.cover,
      prevValueConfig: {
        prevValueKeys: ['prev_value'],
        ratioValueKeys: [],
      },
      valueFormatter,
    });
  };

  return {
    key,
    width: localeWidth,
    align: 'center',
    header: () => {
      /** 当不是环比排序时，表格标题文本有提示文本 */
      const showTextBubble = currentSortKey !== `${key}_1`;
      return (
        <CloumsCenter width={localeWidth} align={'right'}>
          <SortBy
            title={title}
            defaultKey={currentSortKey}
            defaultValue={currentSortValue}
            svgIcon={svgIcon}
            isNoDropdown={isNoDropdown}
            list={[
              {
                key: `${key}_0`,
                sortMetric,
                // orderSource: dataSource,
                text: title,
                title,
                ratioType: 0,
              },
              {
                key: `${key}_1`,
                sortMetric,
                // orderSource: dataSource,
                text: `${title}:${formatMessage({ id: 'dbi_change' })}(%)`,
                title: `${title}(%)`,
                ratioType: 1,
              },
            ]}
            onChange={onSortChage}
            svgTip={
              <DataSourceBubbleInfo
                dataOfDom={title}
                metricKey={sortMetric}
                entityType={entityType}
                comesFormDom={
                  <>
                    <img src={getDataSourceIcon(dataSource)} />
                    {DATASOURCE_NAME[dataSource]}
                  </>
                }
                dataSource={dataSource}
              />
            }
            content={showTextBubble && formatMessage({ id: textContent })}
          />
        </CloumsCenter>
      );
    },
    render: (cvm: any) => {
      if (sortMetric === 'gamalytic__pcu' || sortMetric === 'steamfollowers' || sortMetric === 'source_steam__pcu') {
        const metrics = cvm?.other_metric || [];
        const metric = metrics.find((item: any) => {
          return item?.metric === sortMetric;
        });
        const value = valueFormat(metric?.value);
        const dataCompareData = getDataCompareData(cvm, metric);
        const growthDataObj = growthFormat({
          value: metric?.growth_ratio,
          valueType: 'pointValue',
          hasPoint: 'lessThanOne',
          fixedNum: 2,
          maxNumber: 99999,
          zeroValue: '0',
        });
        return (
          <CloumsCenter width={localeWidth} align={'center'}>
            <TableShowData
              maxNumber={'99999+%'}
              value={value}
              type={growthDataObj?.type}
              growth={growthDataObj?.value}
              dataCompareData={dataCompareData}
            />
          </CloumsCenter>
        );
      }
      const metrics = cvm?.store_rank || [];
      const metric = metrics.find((item: any) => {
        return item?.data_source === sortMetric;
      });
      const value = valueFormat(metric?.value);
      const dataCompareData = getDataCompareData(cvm, metric);
      const growthDataObj = growthFormat({
        value: metric?.growth_ratio,
        valueType: 'rankValue',
        hasPoint: 'none',
        fixedNum: 0,
        maxNumber: 9999,
        zeroValue: '0',
      });
      return (
        <CloumsCenter width={localeWidth} align={'center'}>
          <TableShowData
            maxNumber={'9999+'}
            value={value}
            type={growthDataObj?.type}
            growth={growthDataObj?.value}
            dataCompareData={dataCompareData}
          />
        </CloumsCenter>
      );
    },
  };
};
